import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrenchSouthernTerritories = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1643_5914)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H20V20H0V0Z",
				fill: "#002395"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H12.1992V8.20312H0V0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H4V8H0V0Z",
				fill: "#002395"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 0H12V8H8V0Z",
				fill: "#ED2939"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0312 9.14844L11.6758 10.1758H13.5078V13.75L12.1289 11.6016L10.2812 14.5508H11.1797L12.1328 12.8516L14.082 16.3516L16.0312 12.8516L16.9805 14.5508H17.8789L16.0352 11.6016L14.6602 13.75V11.7734H15.4844L16.0977 10.7969H14.6602V10.1719H16.4922L17.1367 9.14844H11.0312ZM13.1797 13.5234H11.1797V14.2266H13.1797V13.5234ZM16.9805 13.5234H14.9805V14.2266H16.9805V13.5234Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.0813 17.05L14.6963 18.95L13.0813 17.775H15.0813L13.4663 18.95L14.0813 17.05Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.8313 15.35L12.4463 17.25L10.8313 16.075H12.8313L11.2163 17.25L11.8313 15.35Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.3313 15.35L16.9463 17.25L15.3313 16.075H17.3313L15.7163 17.25L16.3313 15.35Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.93124 10.3L10.5462 12.2L8.93124 11.025H10.9312L9.31624 12.2L9.93124 10.3Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.2312 10.3L18.8462 12.2L17.2312 11.025H19.2312L17.6162 12.2L18.2312 10.3Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1643_5914",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 10,
			fill: "white"
		})
	}) })]
});
export default SvgFrenchSouthernTerritories;
